/**
 * Departamentele firmei, pentru task-uri (Madalin, 12.10.2026).
 *
 * Fiecare task apartine unui departament si il preia un om de acolo — nu i se atribuie cuiva.
 * Departamentul omului se deduce din ROLUL lui; nu se alege. `slug` e chiar slug-ul categoriei
 * din `task_categories`, deci baza si codul vorbesc despre acelasi lucru.
 *
 * Slug-ul ramane `administrativ` (rol, categorie in baza), dar pe ecran departamentul se numeste
 * „Operațional" — asa se numeste in firma (Madalin, 14.10.2026).
 *
 * „Administrativ" urmeaza fila „Departament" din versiunea de dinainte (`DEPARTAMENT_VIZIBIL`):
 * rolul `administrativ` era deja un departament al lui. Categoriile „HR" si „Generale", care nu
 * apartineau niciunui rol, au intrat aici la migrare.
 */
export const DEPARTAMENTE = [
    { slug: 'contabilitate', nume: 'Contabilitate' },
    { slug: 'vanzari', nume: 'Vânzări' },
    { slug: 'marketing', nume: 'Marketing' },
    { slug: 'depozit', nume: 'Depozit' },
    { slug: 'administrativ', nume: 'Operațional' },
    /*
      „Admin" (16.10–19.10.2026) a iesit: task-urile din contact@ sunt acum PRIVATE ale lui Victor
      si, de pe 28.10.2026, ale lui Adrian (`inbound_mailbox_taskuri_la`), iar „Ale mele" +
      privatul pentru oricine acopera ce facea. Randul ramane in baza, inchis, pentru istoric.
    */
];
/** `null` = adminul: nu e intr-un departament, vede si muta tot. */
export const DEPARTAMENT_DIN_ROL = {
    admin: null,
    contabilitate: 'contabilitate',
    vanzari: 'vanzari',
    manager_vanzari: 'vanzari',
    marketing: 'marketing',
    depozit: 'depozit',
    administrativ: 'administrativ',
};
export function departamentulRolului(role) {
    return DEPARTAMENT_DIN_ROL[role] ?? null;
}
/**
 * „Toate departamentele", la un task trimis deodata la mai multe (16.10.2026). Deschis tuturor,
 * nu doar adminilor, din 19.10.2026 (Madalin: oricine atribuie oricui).
 */
export const TOATE_DEPARTAMENTELE = DEPARTAMENTE.map((d) => d.slug);
export function esteDepartament(slug) {
    return DEPARTAMENTE.some((d) => d.slug === slug);
}
export function numeDepartament(slug) {
    return DEPARTAMENTE.find((d) => d.slug === slug)?.nume ?? slug;
}
/**
 * Starile unui task pe tablou. `de_preluat` e singura fara responsabili — si e obligatoriu fara;
 * toate celelalte deschise au cel putin unul. Invariantul e pazit si in baza (trigger amanat
 * `task_de_preluat_fara_responsabil`, 19.10.2026).
 */
export const STARI_TASK = [
    'de_preluat',
    'todo',
    'in_progress',
    'in_asteptare',
    'done',
    'cancelled',
];
export const ETICHETA_STARE_TASK = {
    de_preluat: 'De preluat',
    todo: 'De făcut',
    in_progress: 'În lucru',
    in_asteptare: 'Așteaptă',
    done: 'Gata',
    cancelled: 'Respins',
};
/** Starile care au un responsabil si inca o treaba de facut. */
export const STARI_PRELUATE = ['todo', 'in_progress', 'in_asteptare'];
/** Cat sta „Gata" sub tablou; tot ce e mai vechi se vede in Arhiva. */
export const ZILE_GATA_PE_TABLOU = 7;
/**
 * Actiunile de pe tablou. Fiecare are o singura stare-tinta; regula cine si din ce stare o poate
 * face sta in API (`reguliTask.ts`), singurul loc care decide.
 */
export const ACTIUNI_TASK = [
    'preia',
    'incepe',
    'asteapta',
    'reia',
    'gata',
    'renunta',
    'redeschide',
    'respinge',
    /*
      Scoate un task deschis de pe tablou, in Arhiva, fara sa-l stearga (Madalin, 16.10.2026: „ca
      sa ramana task-ul in istoric"). Stergerea ramane doar a adminului.
    */
    'arhiveaza',
    /*
      Doar pe un task PRIVAT (16.10.2026): in locul lui „renunta", care l-ar intoarce la „De
      preluat", la vedere. Scoate omul de pe task; cand nu mai ramane nimeni, task-ul se intoarce
      la cel care l-a dat (19.10.2026: oricine poate da un privat).
    */
    'da_inapoi',
];
/**
 * Nota din traseu la arhivare: `arhivat`, apoi, daca exista, ` — ` si motivul. Arhivatul si
 * respinsul au aceeasi stare (`cancelled`); nota ii desparte, in Arhiva si in traseu.
 */
export const MARCAJ_ARHIVAT = 'arhivat';
export const SEPARATOR_NOTA = ' — ';
/** Nota unei mutari in `cancelled` vine dintr-o arhivare (nu dintr-o respingere)? */
export function esteNotaArhivare(nota) {
    return nota === MARCAJ_ARHIVAT || !!nota?.startsWith(MARCAJ_ARHIVAT + SEPARATOR_NOTA);
}
/** Nota fara marcaj — ce a scris omul. */
export function faraMarcajArhivare(nota) {
    if (!esteNotaArhivare(nota))
        return nota ?? null;
    return nota.slice(MARCAJ_ARHIVAT.length + SEPARATOR_NOTA.length) || null;
}
//# sourceMappingURL=departamente.js.map